import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

const FilterButtonSelect = ({ options, setFilterBy, filterBy }) => {
  const [dropDownList, setDropDownList] = useState(false);
  const menuClass = `dropdown-menu${dropDownList ? " show" : ""}`;

  return (
    <button
      onBlur={() => {
        setDropDownList(false);
      }}
      onClick={() => {
        setDropDownList(!dropDownList);
      }}
      className="btn btn-custom-filter-borderless position-relative dropdown-toggle border-0"
      type="button"
    >
      {filterBy.charAt(0).toUpperCase() + filterBy.slice(1)}  {dropDownList ? <FaChevronUp color="green" className="ms-2"/>:<FaChevronDown color="green" className="ms-2"/>}
      <ul className={menuClass + " top-0 w-100"} style={{ marginTop: "3.5em" }}>
        {options.map((opt,index) => (
          <li key={index}>
            <span
              className="dropdown-item pointer"
              onClick={() => {
                setFilterBy(opt?.value);
              }}
            >
              {opt?.label}
            </span>
          </li>
        ))}
      </ul>
    </button>
  );
};

export default FilterButtonSelect;
